<template>
  <div class="content">
    <div class="bodycontent">
      <div class="oil-info">
        <span>油品信息</span>
      </div>
      <div class="oil-con">
        <el-form
          :model="formData"
          ref="formData"
          label-width="100px"
          :rules="rules"
          style="width:50%"
        >
          <el-form-item label="类别/名称" prop="name">
            <el-cascader
              v-model="nameValue"
              :options="nameOption"
              :props="{ expandTrigger: 'hover' }"
              class="input_box_small"
              @change="handleChange"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="价格类型">
            <el-radio-group v-model="formData.is_spec">
              <el-radio :label="0">统一价格</el-radio>
              <el-radio :label="1">多门店价格</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" v-if="formData.is_spec">
            <el-table :data="multiPrice" style="width:650px" border>
              <el-table-column label="门店">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.id"
                    placeholder="请选择门店"
                    @change="resetOptions"
                  >
                    <el-option
                      v-for="item in store_options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.disable"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="价格">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.price"
                    placeholder="请输入价格"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="80px">
                <template slot="header">
                  <el-button type="text" @click="addPriceLine()"
                    >添加一行</el-button
                  >
                </template>
                <template slot-scope="scope">
                  <el-button type="text" @click="multiPriceDel(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <!-- <el-form-item label="所属门店" prop="room_id" v-if="formData.is_spec">
            <el-select v-model="multiId0" placeholder="请选择门店">
              <el-option
                v-for="item in store_options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
            <span class="price_label">价格</span>
            <el-input class="input_box_small" v-model="multiPrice0"></el-input>
            <el-button type="primary" style="margin-left:20px" @click="addPriceLine()">添加一行</el-button>
          </el-form-item> -->
        </el-form>
        <el-form
          :model="formData"
          ref="formData"
          label-width="100px"
          :rules="rules"
          style="width:29%"
        >
          <el-form-item label="油品价格" prop="price">
            <el-input
              v-model="formData.price"
              class="input_box_small"
              @blur="changePrice(2)"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="油品分类" prop="mktprice" class="oiltype">
            <el-select
              v-model="old_type"
              placeholder="请选择分类"
              style="width:150px"
            >
              <el-option
                v-for="item in oil_typeArr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button type="primary" style="float:right" @click="addOilType"
              >添加分类</el-button
            >
          </el-form-item> -->
        </el-form>
      </div>
      <div class="bottom_btn">
        <el-button type="primary" @click="save">提交</el-button>
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getSelectArr, goodsAdd, goodsDetail, goodsEdit } from "@/api/vip";
import { storeSelect } from "@/api/employee";

export default {
  components: {},
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  data() {
    return {
      formData: {
        price: "",
      },
      if_add: true, //是否是新增
      rules: {
        name: [
          {
            required: true,
            min: 2,
            max: 4,
            message: "名称不规范，请重新输入",
            trigger: "blur",
          },
        ],
        price: [{ required: true, message: "请输入价格", trigger: "submit" }],
      },
      old_type: "",
      multiPrice0: "",
      store_options: [],
      oil_typeArr: [],
      multiPrice: [{ id: "", price: "" }], //多门店价格
      nameValue: [],
      nameOption: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initStoreType();
      this.getOilTypeSelect();
    });
  },
  methods: {
    // 添加分类
    addOilType() {
      this.$prompt("请输入类别名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.$message({
          type: "success",
          message: "已添加油品类别: " + value,
        });
      });
    },
    getOilTypeSelect() {
      getSelectArr(this.token, this.app_id).then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.oil_typeArr = res.data;
            this.nameOption = [];
            let data = [
              { value: "30元大礼包", label: "30元大礼包" },
              { value: "40元大礼包", label: "40元大礼包" },
              { value: "50元大礼包", label: "50元大礼包" },
              { value: "60元大礼包", label: "60元大礼包" },
              { value: "70元大礼包", label: "70元大礼包" },
              { value: "80元大礼包", label: "80元大礼包" },
              { value: "90元大礼包", label: "90元大礼包" },
              { value: "100元大礼包", label: "100元大礼包" },
              { value: "110元大礼包", label: "110元大礼包" },
            ];
            let qiyouData = [
              { value: "92#", label: "92#" },
              { value: "92#乙醇汽油", label: "92#乙醇汽油" },
              { value: "95#", label: "95#" },
              { value: "95#乙醇汽油", label: "95#乙醇汽油" },
              { value: "98#", label: "98#" },
              { value: "89#", label: "89#" },
              { value: "92", label: "92" },
              { value: "95", label: "95" },
              { value: "98", label: "98" },
              { value: "89", label: "89" },
              { value: "92开票", label: "92开票" },
              { value: "95开票", label: "95开票" },
              { value: "98开票", label: "98开票" },
              { value: "89开票", label: "89开票" },
              { value: "E95", label: "E95" },
              { value: "E92", label: "E92" },
            ];
            let chaiyouData = [
              { value: "10#", label: "10#" },
              { value: "5#", label: "5#" },
              { value: "0#", label: "0#" },
              { value: "0柴油", label: "0柴油" },
              { value: "0#生物柴油", label: "0#生物柴油" },
              { value: "-10#", label: "-10#" },
              { value: "-20#", label: "-20#" },
              { value: "-35#", label: "-35#" },
              { value: "-50#", label: "-50#" },
              { value: "10", label: "10" },
              { value: "5", label: "5" },
              { value: "0", label: "0" },
              { value: "-10", label: "-10" },
              { value: "-20", label: "-20" },
              { value: "-35", label: "-35" },
              { value: "-50", label: "-50" },
              { value: "10开票", label: "10开票" },
              { value: "5开票", label: "5开票" },
              { value: "0开票", label: "0开票" },
              { value: "-10开票", label: "-10开票" },
              { value: "-20开票", label: "-20开票" },
              { value: "-35开票", label: "-35开票" },
              { value: "-50开票", label: "-50开票" },
              { value: "B5", label: "B5" },
            ];
            let otherData = [
              { value: "快速买单", label: "快速买单" },
              { value: "便利店", label: "便利店" },
              { value: "购券", label: "购券" },
            ];
            this.oil_typeArr.forEach((item) => {
              this.nameOption.push({
                value: item.id,
                label: item.name,
                children: item.children || [],
              });
              // if (item.name == "汽油") {
              //   this.nameOption.push({
              //     value: item.id,
              //     label: item.name,
              //     children:
              //       this.app_id == 2262 ? [...qiyouData, ...data] : qiyouData,
              //   });
              // } else if (item.name == "柴油") {
              //   this.nameOption.push({
              //     value: item.id,
              //     label: item.name,
              //     children: chaiyouData,
              //   });
              // } else if (item.name == "LNG") {
              //   this.nameOption.push({
              //     value: item.id,
              //     label: item.name,
              //     children: [{ value: "天然气", label: "天然气" }],
              //   });
              // } else if (item.name == "CNG") {
              //   this.nameOption.push({
              //     value: item.id,
              //     label: item.name,
              //     children: [{ value: "压缩天然气", label: "压缩天然气" }],
              //   });
              // } else if (item.name == " ") {
              //   this.nameOption.push({
              //     value: item.id,
              //     label: item.name,
              //     children:
              //       this.app_id == 2302
              //         ? [...otherData, { value: "潍柴致护", label: "潍柴致护" }]
              //         : this.app_id == 2314
              //         ? [...otherData, { value: "特惠礼包", label: "特惠礼包" }]
              //         : otherData,
              //   });
              // } else if (item.name == "甲醇") {
              //   this.nameOption.push({
              //     value: item.id,
              //     label: item.name,
              //     children: [
              //       { value: "M100", label: "M100" },
              //       { value: "M15", label: "M15" },
              //       { value: "M5", label: "M5" },
              //     ],
              //   });
              // }
            });
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 门店列表
    initStoreType() {
      storeSelect({ token: this.token, app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          if (res.data.length > 0) {
            this.store_options = res.data;
            this.store_options.forEach((item) => {
              item.disable = false;
            });
          }
          this.initForm();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    initForm() {
      if (this.$route.query.sid) {
        this.if_add = false;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.$route.query.sid,
        };
        goodsDetail(data).then((res) => {
          var edit = Object.assign({}, res.data);
          this.nameValue = [edit.type_id, edit.name];
          if (edit.is_spec) {
            //多门店价格
            // data对象类型转数组类型
            var arr = [];
            for (var i in edit.specs) {
              arr.push(edit.specs[i]);
            }
            this.multiPrice = [];
            arr.forEach((item, index) => {
              this.multiPrice.push({ id: item.room_id, price: item.price });
              this.store_options.forEach((options) => {
                if (options.id == item.room_id) {
                  options.disable = true;
                }
              });
            });
          }
          delete edit.store_id;
          delete edit.create_time;
          delete edit.update_time;
          this.formData = Object.assign({}, edit);
        });
      } else {
        this.formData = {
          is_spec: 0,
          price: "",
        };
      }
    },
    // 添加一行多门店价格
    addPriceLine() {
      this.multiPrice.push({ id: "", price: "" });
    },
    // 删除多门店价格
    multiPriceDel(i) {
      if (this.multiPrice[i].id) {
        this.store_options.forEach((item) => {
          if (item.id == this.multiPrice[i].id) {
            item.disable = false;
          }
        });
      }
      this.multiPrice.splice(i, 1);
    },
    //选择门店防止重复
    resetOptions() {
      this.store_options.forEach((item) => {
        item.disable = false;
      });
      this.multiPrice.forEach((item) => {
        this.store_options.forEach((options) => {
          if (options.id == item.id) {
            options.disable = true;
          }
        });
      });
    },
    //保存表单
    save() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          // if (this.old_type == "") return this.$message("请选择油品类别");
          var data = Object.assign({}, this.formData);
          data.token = this.token;
          data.app_id = this.app_id;
          data.unit = "升";
          data.name = this.nameValue[1];
          data.type_id = this.nameValue[0];
          if (data.is_spec == 0) {
            //统一价格
            delete data.spec;
          } else {
            //多门店价格
            // delete data.price;
            var itemData = {};
            this.multiPrice.forEach((item) => {
              itemData[item.id] = {
                price: item.price,
              };
            });
            data.specs = itemData;
          }
          // return false;
          if (this.if_add) {
            //新增
            goodsAdd(data).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          } else {
            //修改
            goodsEdit(data).then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          }
        }
      });
    },
    goback() {
      this.$router.go(-1);
    },
    UpNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, "");
    },
    // 价格保留两位小数
    changePrice(i) {
      if (i == 1) {
        if (this.formData.mktprice !== "") {
          this.formData.mktprice = Number(this.formData.mktprice).toFixed(2);
          if (isNaN(this.formData.mktprice)) {
            this.formData.mktprice = "";
          }
        }
      } else {
        if (this.formData.price !== "") {
          this.formData.price = Number(this.formData.price).toFixed(2);
          if (isNaN(this.formData.price)) {
            this.formData.price = "";
          }
        }
      }
    },
    handleChange(value) {
      console.log(value);
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
@import "../sub_com.scss";
.bodycontent {
  background: #ffffff;
}
.input_box {
  width: 400px;
}
.tips {
  color: #888;
}
.input_box_small {
  width: 300px;
}
.price_label {
  margin: 0 12px 0 20px;
}
.state_text {
  color: #999;
  font-size: 12px;
  height: 20px;
  line-height: 30px;
}
.bottom_btn {
  margin-left: 60px;
  .ml30 {
    margin-left: 30px;
  }
}
.oil-info {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  color: #333333;
  padding-left: 10px;
}
.oil-con {
  width: 80%;
  height: auto;
  display: flex;
  margin-top: 30px;
  .el-form {
    width: 60%;
  }
}
</style>
